import { HtmlBuilder } from './html-builder-interface';

export const unknownHtmlBuilder: HtmlBuilder = (block) => {
  return `
    <p style="color:red;">
      No se pudo extraer la información del bloque de tipo: ${block.tipo}
    </p>
  `;
};
